import React from 'react';
import { PlanDetailsModel } from '../../interfaces/plan.interface';
import Loader from '../Common/Loader';
import { getPlanCurrencyDisplay } from '../../utils/planCurrency';

interface PlanPurchaseItemProps {
  plan?: PlanDetailsModel;
  index?: number;
  loader?: boolean;
  clickedOnPlan?: (plan: PlanDetailsModel) => void;
  userCountry?: string; // Add user country prop
}

const PlanPurchaseItem: React.FC<PlanPurchaseItemProps> = ({
                                                             plan,
                                                             index,
                                                             loader,
                                                             clickedOnPlan,
                                                             userCountry
                                                           }: PlanPurchaseItemProps) => {

  const handlePlanClick = () => {
    if (plan && clickedOnPlan) {
      clickedOnPlan(plan);
    }
  };

  // Get currency display info for the plan
  const currencyDisplay = plan ? getPlanCurrencyDisplay(plan, userCountry) : null;

  return (
    <div
      className={`border rounded-lg  ${plan?.showTopSubscription ? 'bg-boxExtraLightGreen' : 'bg-white'} lg:min-w-80 sm:min-w-full w-full shadow`}
      style={{ border: '1.25px solid #EAECF0' }}>
      <div className="flex flex-col h-44 p-4 sm:p-6 lg:p-8 mb-2 sm:mb-3 lg:mb-4 justify-between relative">
        {plan?.showTopSubscription ? (<div
          className="absolute top-5 sm:top-6 lg:top-7 right-7 pt-0.5 pb-0.5 pl-2 pr-2 bg-storyblueButton rounded-lg text-white font-bold text-base">Limited Time!</div>) : null}
        <h3
          className="text-xl font-bold font-manrope text-storyblueSecondLightText text-left">{plan?.name || 'Plan'}</h3>
        <div className="flex items-end">
          <p className="font-bold font-manrope text-storyblueButton mt-2 leading-none"
             style={{ fontSize: '2.75rem' }}>
            {currencyDisplay?.displayPrice || `$${plan?.cost}`}
          </p>
          <p
            className="text-lg text-gray-500 ml-1">{plan?.chargeCycle === 'one_time' ? 'once off' : plan?.chargeCycle === 'month' ? 'per month' : 'per year'}</p>
        </div>
        <button
          className={`bg-storyblueSecondLightText text-white mt-4 px-4 py-2.5 sm:py-2.5 lg:py-2 rounded-full hover:bg-teal-600 font-bold text-lg sm:text-base flex justify-center items-center ${loader ? 'cursor-not-allowed pointer-events-none' : 'cursor-pointer'}`}
          onClick={handlePlanClick}>
          {plan?.trialDays ? `Try ${plan?.trialDays} Days Free!` : 'Get Started'}
          {loader ? <Loader loader={loader} className={'h-4'} /> : null}
        </button>
      </div>
      <div className="text-left mt-2 sm:mt-3 lg:mt-4 p-4 sm:p-5 lg:p-6 pt-4" style={{ borderTop: '1.25px solid #EAECF0' }}>
        <h3 className="font-bold text-lg text-gray-700 mb-1">FEATURES</h3>
        <ul className="text-sm text-gray-600 space-y-1">
          <li className="flex items-center pt-2 pb-1.5">
            <img src="/check-circle.svg" alt="" className="w-6 mr-2" />
            <span className="mr-1 font-bold">{plan?.storyCreationLimit ? +plan?.storyCreationLimit : 0}</span>
            {plan?.chargeCycle === 'one_time' ? 'Physical + Digital Book' : 'Digital Books'}
          </li>
          <li className="flex items-center pt-2 pb-1.5">
            <img src="/check-circle.svg" alt="" className="w-6 mr-2" />
            <span className="mr-1 font-bold">Unlimited</span> Illustrations
          </li>
          <li className="flex items-center pt-2 pb-1.5">
            <img src="/check-circle.svg" alt="" className="w-6 mr-2" />
            <span className="mr-1 font-bold">Up to {plan?.maxBookPage ?? 32} </span> Page Book
          </li>
          <li className="flex items-center pt-2 pb-1.5">
            <img src="/check-circle.svg" alt="" className="w-6 mr-2" />
            Real-Time Book Editing
          </li>
          <li className="flex items-center pt-2 pb-1.5">
            <img src="/check-circle.svg" alt="" className="w-6 mr-2" />
            Money-Back Guarantee
          </li>
          <li className="flex items-center pt-2 pb-1.5">
            <img src="/check-circle.svg" alt="" className="w-6 mr-2" />
            {plan?.chargeCycle === 'one_time' ? 'Quality 150gsm paper' : 'Cancel Anytime'}
          </li>
        </ul>
      </div>
    </div>

  );
};

export default PlanPurchaseItem;
